import { IRequestModel } from "./models";

export const actionTypes = {
  //REQUEST
  USER_REQUEST_CHANGE_PASSWORD: "USER_REQUEST_CHANGE_PASSWORD",
  USER_REQUEST_CHANGE_PASSWORD_SUCCESS: "USER_REQUEST_CHANGE_PASSWORD_SUCCESS",
  USER_REQUEST_CHANGE_PASSWORD_FAILURE: "USER_REQUEST_CHANGE_PASSWORD_FAILURE",
  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_REQUEST_SUCCESS: "CHANGE_PASSWORD_REQUEST_SUCCESS",
  CHANGE_PASSWORD_REQUEST_FAILURE: "CHANGE_PASSWORD_REQUEST_FAILURE",
  //USER SELECTED
  SET_USER_SELECTED: "SET_USER_SELECTED",
  //PASSWORD POLICY
  PASSWORD_POLICY_REQUEST: "PASSWORD_POLICY_REQUEST",
  PASSWORD_POLICY_REQUEST_SUCCESS: "PASSWORD_POLICY_REQUEST_SUCCESS",
  PASSWORD_POLICY_REQUEST_FAILURE: "PASSWORD_POLICY_REQUEST_FAILURE",
  //RESET
  RESET_STATE_CHANGE_PASSWORD: "RESET_STATE_CHANGE_PASSWORD",

  FORCED_CHANGE_PWD: "FORCED_CHANGE_PWD",
  FORCED_CHANGE_PWD_SUCCESS: "FORCED_CHANGE_PWD_SUCCESS",
  FORCED_CHANGE_PWD_FAILURE: "FORCED_CHANGE_PWD_FAILURE",

  GET_CHANGE_PWD_QUESTIONS: "GET_CHANGE_PWD_QUESTIONS",
  GET_CHANGE_PWD_QUESTIONS_SUCCESS: "GET_CHANGE_PWD_QUESTIONS_SUCCESS",
  GET_CHANGE_PWD_QUESTIONS_FAILURE: "GET_CHANGE_PWD_QUESTIONS_FAILURE",
  VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD:
    "VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD",
  VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_SUCCESS:
    "VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_SUCCESS",
  VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_FAILURE:
    "VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_FAILURE",
  DISPATCH_CHANGE_PWD_ANSWER: "DISPATCH_CHANGE_PWD_ANSWER",

  VERIFY_CHANGE_SEC_QUESTIONS: "VERIFY_CHANGE_SEC_QUESTIONS",
  VERIFY_CHANGE_SEC_QUESTIONS_SUCCESS: "VERIFY_CHANGE_SEC_QUESTIONS_SUCCESS",
  VERIFY_CHANGE_SEC_QUESTIONS_FAILURE: "VERIFY_CHANGE_SEC_QUESTIONS_FAILURE",

  VERIFY_CHANGE_UIGP_OTP: "VERIFY_CHANGE_UIGP_OTP",
  VERIFY_CHANGE_UIGP_OTP_SUCCESS: "VERIFY_CHANGE_UIGP_OTP_SUCCESS",
  VERIFY_CHANGE_UIGP_OTP_FAILURE: "VERIFY_CHANGE_UIGP_OTP_FAILURE",

  VERIFY_CHANGE_ARCOT_OTP: "VERIFY_CHANGE_ARCOT_OTP",
  VERIFY_CHANGE_ARCOT_OTP_SUCCESS: "VERIFY_CHANGE_ARCOT_OTP_SUCCESS",
  VERIFY_CHANGE_ARCOT_OTP_FAILURE: "VERIFY_CHANGE_ARCOT_OTP_FAILURE",
};

//REQUEST
export const dispatchChangePwdAnswer = (answer: string, index: number) => ({
  //string
  type: actionTypes.DISPATCH_CHANGE_PWD_ANSWER,
  payload: { answer, index },
});

export const userRequest = () => ({
  type: actionTypes.USER_REQUEST_CHANGE_PASSWORD,
});

export const userRequestSuccess = (payload: any[]) => ({
  type: actionTypes.USER_REQUEST_CHANGE_PASSWORD_SUCCESS,
  payload,
});

export const userRequestFailure = (err: Error) => ({
  type: actionTypes.USER_REQUEST_CHANGE_PASSWORD_FAILURE,
  err,
});

export const verifySecurityQuestionsChangePwd = (payload: any) => ({
  type: actionTypes.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD,
  payload,
});

export const verifySecurityQuestionsChangePwdSuccess = (payload: any[]) => ({
  type: actionTypes.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_SUCCESS,
  payload,
});

export const verifySecurityQuestionsChangePwdFailure = (err: Error) => ({
  type: actionTypes.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD_FAILURE,
  err,
});

export const getChangePwdSecurityQuestions = () => ({
  type: actionTypes.GET_CHANGE_PWD_QUESTIONS,
});

export const getChangePwdSecurityQuestionsSuccess = (payload: any[]) => ({
  type: actionTypes.GET_CHANGE_PWD_QUESTIONS_SUCCESS,
  payload,
});

export const getChangePwdSecurityQuestionsFailure = (err: Error) => ({
  type: actionTypes.GET_CHANGE_PWD_QUESTIONS_FAILURE,
  err,
});

export const passwordPolicyRequest = (userId: string) => ({
  type: actionTypes.PASSWORD_POLICY_REQUEST,
  userId,
});

export const passwordPolicyRequestSuccess = (payload: any[]) => ({
  type: actionTypes.PASSWORD_POLICY_REQUEST_SUCCESS,
  payload,
});

export const passwordPolicyRequestFailure = (err: Error) => ({
  type: actionTypes.PASSWORD_POLICY_REQUEST_FAILURE,
  err,
});

export const changePasswordRequest = (request: IRequestModel) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST,
  request,
});

export const changePasswordRequestSuccess = (payload: any) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_SUCCESS,
  payload,
});

export const changePasswordRequestFailure = (err: any) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_FAILURE,
  err,
});

//RESET
export const resetState = () => ({
  type: actionTypes.RESET_STATE_CHANGE_PASSWORD,
});

export const setUserSelected = (payload: {
  accountId: string;
  identitySystemId: string;
}) => ({
  type: actionTypes.SET_USER_SELECTED,
  payload,
});

export const verifyChangeQuestionsAction = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_SEC_QUESTIONS,
  payload,
});
export const verifyChangeQuestionsActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_SEC_QUESTIONS_SUCCESS,
  payload,
});
export const verifyChangeQuestionsActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_SEC_QUESTIONS_FAILURE,
  payload,
});

export const verifyChangeUigpAction = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_UIGP_OTP,
  payload,
});
export const verifyChangeUigpActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_UIGP_OTP_SUCCESS,
  payload,
});
export const verifyChangeUigpActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_UIGP_OTP_FAILURE,
  payload,
});

export const verifyChangeArcotAction = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_ARCOT_OTP,
  payload,
});
export const verifyChangeArcotActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_ARCOT_OTP_SUCCESS,
  payload,
});
export const verifyChangeArcotActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_ARCOT_OTP_FAILURE,
  payload,
});

export const forcedChangePwdAction = (payload: any) => ({
  type: actionTypes.FORCED_CHANGE_PWD,
  payload,
});
export const forcedChangePwdActionSuccess = (payload: any) => ({
  type: actionTypes.FORCED_CHANGE_PWD_SUCCESS,
  payload,
});
export const forcedChangePwdActionFailure = (error: any) => ({
  type: actionTypes.FORCED_CHANGE_PWD_FAILURE,
  error,
});
